// extracted by mini-css-extract-plugin
module.exports = {"content":"DemoForm_content__2uJXH","errorPlace":"DemoForm_errorPlace__2a3u_"};